import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  Divider,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LanguageIcon from "@mui/icons-material/Language";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import WifiIcon from "@mui/icons-material/Wifi";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EditIcon from "@mui/icons-material/Edit";
import { baseapi } from "../Environmentalurl";
import axios from "axios";
import {
  ApplicationType,
  date,
  entity_id,
  getGeolocation,
  location,
  locationGeo,
  Platform,
} from "../Utils/Const";
import { Snackbar, Alert, TextField, Button } from "@mui/material";
import { Slider } from "@mui/material";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

/* ---------- Reusable Card ---------- */
const LimitCard = ({ icon, title, limits, isExpanded, onEdit, children }) => (
  <Card sx={{ borderRadius: 3, mb: 2 }}>
    <CardContent>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" gap={2}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              bgcolor: "#eef3ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </Box>

          <Box>
            <Typography fontWeight={600}>{title}</Typography>

            {!isExpanded &&
              limits.map((item, i) => (
                <Box
                  key={i}
                  display="flex"
                  justifyContent="space-between"
                  width={220}
                  mt={0.5}
                >
                  <Typography fontSize={13} color="text.secondary">
                    {item.label}
                  </Typography>
                  <Typography fontSize={13} fontWeight={600}>
                    ₹{item.value}
                  </Typography>
                </Box>
              ))}
          </Box>
        </Box>

        <IconButton onClick={onEdit}>
          <EditIcon sx={{ color: "#1fa86c" }} />
        </IconButton>
      </Box>

      {isExpanded && <Box mt={2}>{children}</Box>}
    </CardContent>
  </Card>
);

/* ---------- MAIN DIALOG ---------- */
export default function ChangeLimitModal({ open, onClose }) {
  const [referenceNumber, setReferenceNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [sessionID, setSessionID] = useState("");
  const [maskedCardUI, setMaskedCardUI] = useState("");
  const [perTxn, setPerTxn] = useState(1000);
  const [perDay, setPerDay] = useState(5000);
  const [tapPay, setTapPay] = useState(2000);
  const [atmCash, setAtmCash] = useState(5000);
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [expandedCard, setExpandedCard] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [editableLimits, setEditableLimits] = useState(null);
  const [limitsMaster, setLimitsMaster] = useState([]);
  const [responseMsg, setResponseMsg] = useState("");
  const [responseType, setResponseType] = useState("success"); // success | error
  const [responseOpen, setResponseOpen] = useState(false);
  const [resultDialogOpen, setResultDialogOpen] = useState(false);
  const [resultType, setResultType] = useState("success"); // success | error
  const [resultMessage, setResultMessage] = useState("");
  const inputRefs = useRef([]);
  const [limits, setLimits] = useState({
    onlinePerTxn: "0.00",
    onlinePerDay: "0.00",

    posPerTxn: "0.00",
    posPerDay: "0.00",

    nfcPerTxn: "0.00",
    nfcPerDay: "0.00",

    atmPerTxn: "0.00",
    atmPerDay: "0.00",
    atmPerMonth: "0.00",
  });

  // const [editableLimits, setEditableLimits] = useState({
  //   onlinePerTxn: "",
  //   onlinePerDay: "",

  //   posPerTxn: "",
  //   posPerDay: "",

  //   nfcPerTxn: "",
  //   nfcPerDay: "",

  //   atmPerTxn: "",
  //   atmPerDay: "",
  //   atmPerMonth: "",
  // });

  const ip = useIPAddress();
  useEffect(() => {
    if (!open) return;
    const ref = sessionStorage.getItem("rupayRefNo") || "";
    const mob = sessionStorage.getItem("mobileNumber") || "";
    const sess = sessionStorage.getItem("SessionID") || "";

    setReferenceNumber(ref);
    setMobileNumber(mob);
    setSessionID(sess);

    const fetchCardStatus = async () => {
      try {
        const res = await api.post(`${baseapi}/getcardstatus`, {
          ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
          Mobilenumber: mob,
          ReferenceNumber: ref,
          Platform,
          ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
          SessionID: sess,
        });

        setMaskedCardUI(res.data.MaskedCard);

        setLimits({
          // ONLINE
          onlinePerTxn: res.data.PerTrxnLimit,
          onlinePerDay: res.data.PerDayLimit,

          // POS / CARD SWIPE
          posPerTxn: res.data.POSPerTransaction,
          posPerDay: res.data.POSLimitPerDay,

          // NFC / TAP & PAY
          nfcPerTxn: res.data.NFCLimitPerTransaction,
          nfcPerDay: res.data.NFCLimitPerDay,

          // ATM
          atmPerTxn: res.data.ATMLimitPerTransaction,
          atmPerDay: res.data.ATMLimitPerDay,
          atmPerMonth: res.data.ATMLimitPermonth,
        });
        setEditableLimits({
          onlinePerTxn: Number(res.data.PerTrxnLimit),
          onlinePerDay: Number(res.data.PerDayLimit),

          posPerTxn: Number(res.data.POSPerTransaction),
          posPerDay: Number(res.data.POSLimitPerDay),

          nfcPerTxn: Number(res.data.NFCLimitPerTransaction),
          nfcPerDay: Number(res.data.NFCLimitPerDay),

          atmPerTxn: Number(res.data.ATMLimitPerTransaction),
          atmPerDay: Number(res.data.ATMLimitPerDay),
          atmPerMonth: Number(res.data.ATMLimitPermonth),
        });
        setLimitsMaster(res.data.LimitsMaster || []);
      } catch (err) {
        console.error("getcardstatus failed", err);
      }
    };
    resetUIState();
    fetchCardStatus();
  }, [open]);

  const getCardStatus = async () => {
    const res = await api.post(`${baseapi}/getcardstatus`, {
      ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
      Mobilenumber: mobileNumber,
      ReferenceNumber: referenceNumber,
      Platform,
      ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      MachineID: ip,
      SessionID: sessionID,
    });

    return {
      maskedCard: res.data.MaskedCard,
      encKey: res.data.EncKey,
    };
  };

  const getHexXor = async () => {
    const res = await api.post(`${baseapi}/hexXorgenerator`, {
      rpin: pin,
      mobilenumber: mobileNumber,
    });
    return res.data;
  };

  const encryptRpin = async (hexXor, encKey) => {
    const res = await api.post(`${baseapi}/ewalletRupayEncryption3DES`, {
      ReqType: "Jan_Aadhaar_eWallet_RupayEncryption3DES",
      Mobilenumber: mobileNumber,
      Enc_Key: encKey,
      Date: date,
      Hex_XOR_Value: hexXor,
      Platform,
      SessionID: sessionID,
      ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      MachineID: ip,
    });

    return res.data.RPIN;
  };

  /* ---------------- FINAL UPDATE ---------------- */

  const handleUpdate = async () => {
    if (!pin || pin.length !== 4) {
      setResponseMsg("Please enter valid TPIN");
      setResponseType("error");
      setResponseOpen(true);
      return;
    }

    try {
      setLoading(true);

      // 1️⃣ Card Status
      const { maskedCard, encKey } = await getCardStatus();

      // 2️⃣ XOR
      const hexXor = await getHexXor();

      // 3️⃣ Encrypt PIN
      const encryptedPin = await encryptRpin(hexXor, encKey);

      // 4️⃣ FINAL PAYLOAD (UPDATED FROM SLIDERS)
      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_RuPayTransactionLimitUpdate",
        ReferenceNumber: referenceNumber,

        PerTrxnLimit: String(editableLimits.onlinePerTxn),
        PerDayLimit: String(editableLimits.onlinePerDay),
        PerMonthLimit: String(editableLimits.onlinePerTxn),

        POSPerTransaction: String(editableLimits.posPerTxn),
        POSPerday: String(editableLimits.posPerDay),
        POSPerMonth: String(editableLimits.posPerTxn),

        NFCPerTransaction: String(editableLimits.nfcPerTxn),
        NFCPOSPerday: String(editableLimits.nfcPerDay),
        NFCPerMonth: String(editableLimits.nfcPerTxn),

        ATMPerTransaction: String(editableLimits.atmPerTxn),
        ATMPOSPerday: String(editableLimits.atmPerDay),
        ATMPerMonth: String(editableLimits.atmPerMonth),

        CardNumber: maskedCard,
        R_PIN: encryptedPin,
        Mobilenumber: mobileNumber,
        SessionID: sessionID,
        Date: date,
        Platform,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
      };

      const res = await api.post(
        `${baseapi}/eWalletRuPayTransactionLimitUpdate`,
        payload,
      );

      setResultMessage(res.data.Message);
      setResultType(res.data.Response_Code === "9000" ? "success" : "error");
      setResultDialogOpen(true);

      if (res.data.Response_Code === "9000") {
        setTimeout(() => {
          setResultDialogOpen(false);
          onClose(); // close main dialog
        }, 1500);
      }
    } catch (err) {
      setResponseMsg("System error. Please try again.");
      setResponseType("error");
      setResponseOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const getMinMax = (mode, type) => {
    const item = limitsMaster.find(
      (l) => l.Mode === mode && l.LimitType === type,
    );
    return {
      min: item?.MinLimit ?? 0,
      max: item?.MaxLimit ?? 0,
    };
  };

  const resetUIState = () => {
    setExpandedCard(null);
    setPin("");
    setLoading(false);
    setResultDialogOpen(false);
    setResultType("success");
    setResultMessage("");

    // Reset editable limits back to fetched limits
    setEditableLimits((prev) =>
      prev
        ? {
            onlinePerTxn: Number(limits.onlinePerTxn),
            onlinePerDay: Number(limits.onlinePerDay),

            posPerTxn: Number(limits.posPerTxn),
            posPerDay: Number(limits.posPerDay),

            nfcPerTxn: Number(limits.nfcPerTxn),
            nfcPerDay: Number(limits.nfcPerDay),

            atmPerTxn: Number(limits.atmPerTxn),
            atmPerDay: Number(limits.atmPerDay),
            atmPerMonth: Number(limits.atmPerMonth),
          }
        : prev,
    );
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        resetUIState();
        onClose();
      }}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 3,
          bgcolor: "#f6f7fb",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          bgcolor: "#1fa86c",
          color: "#fff",
          p: 1.5,
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <ArrowBackIcon />
        </IconButton>

        <Typography fontWeight={600} ml={1}>
          Transaction Limits
        </Typography>
      </Box>

      <Divider />

      {/* BODY */}
      <Box p={2}>
        <LimitCard
          icon={<LanguageIcon color="primary" />}
          title="Online Transactions"
          isExpanded={expandedCard === "ONLINE"}
          onEdit={() => {
            setExpandedCard((prev) => (prev === "ONLINE" ? null : "ONLINE"));
            setSnackOpen(true);
          }}
          limits={[
            { label: "Per Transaction Limit", value: limits.onlinePerTxn },
            { label: "Per Day Limit", value: limits.onlinePerDay },
          ]}
        >
          {/* 🔽 REPLACE SLIDERS WITH THIS */}

          {(() => {
            const { min, max } = getMinMax("Online", "Per Transaction");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Transaction
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.onlinePerTxn}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.onlinePerTxn ?? min}
                  min={min}
                  max={max}
                  track="normal"
                  valueLabelDisplay="on"
                  valueLabelFormat={(v) => `₹${v}`}
                  sx={{
                    color: "#1fa86c",
                    "& .MuiSlider-thumb": {
                      width: 16,
                      height: 16,
                    },
                  }}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, onlinePerTxn: v })
                  }
                />
              </>
            );
          })()}

          {(() => {
            const { min, max } = getMinMax("Online", "Per Day");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Day
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.onlinePerDay}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.onlinePerDay ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, onlinePerDay: v })
                  }
                />
              </>
            );
          })()}
        </LimitCard>

        <LimitCard
          icon={<CreditCardIcon sx={{ color: "#7c4dff" }} />}
          title="Card Swipe"
          isExpanded={expandedCard === "POS"}
          onEdit={() => {
            setExpandedCard((prev) => (prev === "POS" ? null : "POS"));
            setSnackOpen(true);
          }}
          limits={[
            { label: "Per Transaction Limit", value: limits.posPerTxn },
            { label: "Per Day Limit", value: limits.posPerDay },
          ]}
        >
          {/* PER TRANSACTION */}
          {(() => {
            const { min, max } = getMinMax("POS", "Per Transaction");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Transaction
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.posPerTxn}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.posPerTxn ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, posPerTxn: v })
                  }
                />
              </>
            );
          })()}

          {/* PER DAY */}
          {(() => {
            const { min, max } = getMinMax("POS", "Per Day");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Day
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.posPerDay}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.posPerDay ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, posPerDay: v })
                  }
                />
              </>
            );
          })()}
        </LimitCard>

        <LimitCard
          icon={<WifiIcon sx={{ color: "#00bcd4" }} />}
          title="Tap and Pay"
          isExpanded={expandedCard === "NFC"}
          onEdit={() => {
            setExpandedCard((prev) => (prev === "NFC" ? null : "NFC"));
            setSnackOpen(true);
          }}
          limits={[
            { label: "Per Transaction Limit", value: limits.nfcPerTxn },
            { label: "Per Day Limit", value: limits.nfcPerDay },
          ]}
        >
          {/* PER TRANSACTION */}
          {(() => {
            const { min, max } = getMinMax("NFC", "Per Transaction");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Transaction
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.nfcPerTxn}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.nfcPerTxn ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, nfcPerTxn: v })
                  }
                />
              </>
            );
          })()}

          {/* PER DAY */}
          {(() => {
            const { min, max } = getMinMax("NFC", "Per Day");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Day
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.nfcPerDay}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.nfcPerDay ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, nfcPerDay: v })
                  }
                />
              </>
            );
          })()}
        </LimitCard>

        <LimitCard
          icon={<AccountBalanceIcon sx={{ color: "#ff7043" }} />}
          title="ATM Cash Withdrawal"
          isExpanded={expandedCard === "ATM"}
          onEdit={() => {
            setExpandedCard((prev) => (prev === "ATM" ? null : "ATM"));
            setSnackOpen(true);
          }}
          limits={[
            { label: "Per Transaction Limit", value: limits.atmPerTxn },
            { label: "Per Day Limit", value: limits.atmPerDay },
            { label: "Per Month Limit", value: limits.atmPerMonth },
          ]}
        >
          {/* PER TRANSACTION */}
          {(() => {
            const { min, max } = getMinMax("ATM", "Per Transaction");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Transaction
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.atmPerTxn}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.atmPerTxn ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, atmPerTxn: v })
                  }
                />
              </>
            );
          })()}

          {/* PER DAY */}
          {(() => {
            const { min, max } = getMinMax("ATM", "Per Day");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Day
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.atmPerDay}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.atmPerDay ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, atmPerDay: v })
                  }
                />
              </>
            );
          })()}

          {/* PER MONTH */}
          {(() => {
            const { min, max } = getMinMax("ATM", "Per Month");
            return (
              <>
                <Typography fontSize={12} fontWeight={600}>
                  Per Month
                </Typography>

                <Box display="flex" justifyContent="space-between">
                  <Typography fontSize={11}>₹{min}</Typography>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    color="success.main"
                  >
                    ₹{editableLimits?.atmPerMonth}
                  </Typography>
                  <Typography fontSize={11}>₹{max}</Typography>
                </Box>

                <Slider
                  value={editableLimits?.atmPerMonth ?? min}
                  min={min}
                  max={max}
                  onChange={(e, v) =>
                    setEditableLimits({ ...editableLimits, atmPerMonth: v })
                  }
                />
              </>
            );
          })()}
        </LimitCard>

        <Typography variant="body2" sx={{ mb: 1 }}>
          Enter TPIN
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center" }}>
          {[0, 1, 2, 3].map((index) => (
            <TextField
              key={index}
              type="password"
              value={pin[index] || ""}
              inputRef={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(-1);

                const pinArray = pin.padEnd(4, " ").split("");
                pinArray[index] = value;

                setPin(pinArray.join("").trim());

                if (value && index < 3) {
                  inputRefs.current[index + 1]?.focus();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !pin[index] && index > 0) {
                  inputRefs.current[index - 1]?.focus();
                }
              }}
              inputProps={{
                maxLength: 1,
                inputMode: "numeric",
                style: {
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: 600,
                },
              }}
              sx={{
                width: 60,
                "& .MuiOutlinedInput-root": {
                  height: 60,
                  borderRadius: "14px",
                },
              }}
            />
          ))}
        </Box>
        <Box display={"flex"} justifyContent={"space-evenly"} mt={2}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            sx={{ bgcolor: "#1fa86c", color: "#ffffff" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="large"
            fullWidth
            sx={{ ml: 1, bgcolor: "#1fa86c", color: "#ffffff" }}
            disabled={loading}
            onClick={handleUpdate}
          >
            {loading ? "Updating..." : "Submit"}
          </Button>
        </Box>
      </Box>
      <Dialog
        open={resultDialogOpen}
        onClose={() => setResultDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            px: 3,
            py: 2,
            textAlign: "center",
          },
        }}
      >
        {/* ICON */}
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            mx: "auto",
            mb: 1,
            bgcolor: resultType === "success" ? "#e6f7f0" : "#fdecea",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography fontSize={28}>
            {resultType === "success" ? "✅" : "❌"}
          </Typography>
        </Box>

        {/* TITLE */}
        <Typography
          fontSize={18}
          fontWeight={700}
          color={resultType === "success" ? "#1fa86c" : "#d32f2f"}
        >
          {resultType === "success"
            ? "Limit Updated Successfully"
            : "Update Failed"}
        </Typography>

        {/* MESSAGE */}
        <Typography mt={1} fontSize={14} color="text.secondary">
          {resultMessage}
        </Typography>

        {/* ACTION */}
        <Button
          fullWidth
          variant="contained"
          sx={{
            mt: 3,
            bgcolor: resultType === "success" ? "#1fa86c" : "#d32f2f",
            borderRadius: 2,
            py: 1,
          }}
          onClick={() => {
            resetUIState();
            setResultDialogOpen(false);
            onClose();
          }}
        >
          OK
        </Button>
      </Dialog>
    </Dialog>
  );
}
